import { useState, forwardRef } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "./ui/input";

/**
 * Iter122ez · Input password con toggle visibilità (icona occhio).
 * Wrappa Input di shadcn/ui aggiungendo un bottone in posizione assoluta a destra.
 * Passa qualsiasi prop supportata da <Input> (data-testid, className, placeholder, value, onChange, required, ecc.).
 * Il `data-testid` del bottone di toggle è derivato: `${data-testid}-toggle`.
 */
export const PasswordInput = forwardRef(function PasswordInput(
  { "data-testid": testid, className = "", ...rest }, ref
) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input
        ref={ref}
        type={show ? "text" : "password"}
        data-testid={testid}
        className={`pr-14 ${className}`}
        {...rest}
      />
      <button
        type="button"
        onClick={() => setShow((v) => !v)}
        data-testid={testid ? `${testid}-toggle` : "password-toggle"}
        aria-label={show ? "Nascondi password" : "Mostra password"}
        title={show ? "Nascondi password" : "Mostra password"}
        className="absolute right-3 top-1/2 -translate-y-1/2 p-2 rounded-md text-slate-500 hover:text-brand hover:bg-slate-100 transition-colors"
      >
        {show ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
      </button>
    </div>
  );
});
